import React from 'react'

// Shown on both User Management and Participants Management, so the two never
// drift apart on wording or colour.
//
// Metronic's own label-light-* pairs are unreadable as text: its success token on
// label-light-success measures 1.85:1 and its warning token on label-light-warning
// 1.77:1, against a 4.5:1 floor. The tinted surfaces are kept — they carry the
// meaning at a glance — and only the text colour is overridden, measured at 5.5:1
// and 5.4:1 on those exact backgrounds.
const BOUND = { className: 'label-light-success', color: '#0A6B66', label: 'ผูกแล้ว' }
const UNBOUND = { className: 'label-light-warning', color: '#8A5A00', label: 'ยังไม่ผูก' }

export default function MfaBadge({ enabled }) {
  const state = enabled ? BOUND : UNBOUND
  return (
    <span
      className={`label label-inline font-weight-bold text-nowrap ${state.className}`}
      style={{ color: state.color }}
    >
      {state.label}
    </span>
  )
}
